import { Routes } from '@angular/router';
import { ComplaintsComponent } from './components/complaints/complaints.component';

export const COMPLAINTS_ROUTES: Routes = [
    {
        path: '',
        component: ComplaintsComponent,
    },
];
